<template lang="pug">
  v-navigation-drawer(
    v-model="drawer"
    app
    dark
    dense
  )
    div.primary.d-flex.align-center.justify-self-left.py-1
      v-list-item

        v-list-item-content
          v-list-item-title.title
            router-link( :to="{ name: 'home' }" style="cursor: pointer;" tag="span" ) WWP Admin

    v-list(dense).mt-0

      v-list-group(
        :prepend-icon="section.icon"
        :value="true"
        v-for="(section, index) in sections"
        :key="index"
        active-class="v-list-item--active-white"
      )
        template(v-slot:activator)
          v-list-item-title {{ section.text }}

        v-list-item(
          v-for="(item, index) in section.child"
          :key="index"
          link
          exact
          :to="{ name: item.route }"
        )
          v-list-item-action

          v-list-item-content
            v-list-item-title {{ item.text }}

          v-list-item-action( v-if="item.icon" )
            v-icon {{ item.icon }}

</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number],
      default: null,
    },
  },

  data: () => ({
    sections: [
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Баннеры',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Все баннеры',
            route: 'banners__list',
          },
          {
            icon: 'mdi-plus',
            text: 'Добавить баннер',
            route: 'banners__add',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Достижения',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Все достижения',
            route: 'achievements__list',
          },
          {
            icon: 'mdi-plus',
            text: 'Добавить достижение',
            route: 'achievements__add',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Клубы',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Все клубы',
            route: 'clubs__list',
          },
          {
            icon: 'mdi-plus',
            text: 'Добавить клуб',
            route: 'clubs__add',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Пользователи',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Все пользователи',
            route: 'users__list',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Мероприятия',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Все Мероприятия',
            route: 'events__list',
          },
          {
            icon: 'mdi-plus',
            text: 'Добавить мероприятие',
            route: 'events__add',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Статистика',
        route: 'stats',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Количество партнеров',
            route: 'stats__partners',
          },
        ],
      },
      {
        icon: 'mdi-text-box-multiple-outline',
        text: 'Покупки',
        route: 'goods',
        child: [
          {
            icon: 'mdi-view-list',
            text: 'Шлюзы',
            route: 'goods__gateway',
          },
        ],
      },
    ],
  }),

  computed: {
    drawer: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', JSON.parse(val))
      },
    },
  },
}
</script>

<style lang="scss">
.v-list-item--active-white {
  color: white !important;
}
</style>
